import { STORAGE_KEY } from '../../const/app';

/**
 *
 */
export const clearSession = () => {
  sessionStorage.removeItem(STORAGE_KEY);
};
